import { useEffect, useState } from 'react';
import { useFetchUserProfile } from '@/api/queries/userProfile/useFetchUserProfile';
import { getUserInfo } from '@/utils';
import { getQueryClientInstance } from '@/api/queries/queryClient';
import { useCreateUserProfile } from '@/api/queries/userProfile/useCreateUserProfile';
import { Outlet } from 'react-router-dom';
import { userProfileCacheKeys } from '@/api/queries/userProfile/cacheKeys';
import { useAuthContext } from '@/context/AuthContext';

const queryClient = getQueryClientInstance();

export const UserProfileManager = () => {
  const { token } = useAuthContext();
  const { data, error } = useFetchUserProfile();
  const { mutate: createUserProfile } = useCreateUserProfile();

  const [profileCreated, setProfileCreated] = useState(false);

  useEffect(() => {
    if (!profileCreated && error?.response.status === 404) {
      createUserProfile({
        username: getUserInfo(token).username,
        userId: getUserInfo(token).sub,
        cookieConsentBanner: true,
      });
      queryClient.invalidateQueries({ queryKey: userProfileCacheKeys.fetch });
      setProfileCreated(true);
    }
  }, [error, profileCreated, createUserProfile, token]);

  if (data) {
    return <Outlet />;
  }

  return null;
};
